export default __webpack_public_path__ + "static/B0068-7228753ac531546eba9d3ee95c1b9c44.png";